// lib
import { Fragment } from 'react'
import PropTypes from 'prop-types'

import { TARGET_HELP } from '@aytm/app/stats/page/sidebar/components/lib/helps'

// components
import SidebarPopup from '@aytm/app/stats/page/sidebar/components/SidebarPopup'
import RowCollapsable from '@aytm/app/stats/page/sidebar/target/lib/RowCollapsable'

// styles
import style from '@aytm/app/stats/page/sidebar/target/styles/TargetPanel.module.scss'

const TargetPanelSurvey = ({ root, model }) => {
  const { quotas, quotaType, option_include, option_exclude, custom_quotas } = model

  const renderTargetMarket = () => {
    const isNew = Array.isArray(quotas[0].traits)

    const country_trait = isNew
      ? quotas[0].traits.find(t => 'country' == t.id && t.filtered)
      : quotas[0].details.find(t => 'country' == t[0].toLowerCase())
    const locale_trait = isNew
      ? quotas[0].traits.find(t => 'locale' == t.id && t.filtered)
      : quotas[0].details.find(t => 'locale' == t[0].toLowerCase())

    return country_trait != undefined || locale_trait != undefined ? (
      <div className={style.section}>
        <div className={style['section-title']}>Targeting</div>

        <div className={style.section}>
          {country_trait != undefined ? (
            <div className={style.row}>
              <span className={`${style.column} ${style['column-label']}`}>
                {isNew ? country_trait.label : country_trait[0]}:
              </span>
              <div className={`${style.column} ${style['column-values']}`}>
                {isNew ? country_trait.text : country_trait[1]}
              </div>
            </div>
          ) : null}
          {locale_trait != undefined ? (
            <div className={style.row}>
              <span className={`${style.column} ${style['column-label']}`}>
                {isNew ? locale_trait.label : locale_trait[0]}:
              </span>
              <div className={`${style.column} ${style['column-values']}`}>
                {isNew ? locale_trait.text : locale_trait[1]}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    ) : null
  }

  const renderIncludeOption = () => (
    <div className={style.section}>
      <div className={style['section-title']}>Follow up</div>

      <div className={style.section}>
        {option_include.titles.map((title, index) => (
          <Fragment key={index + 1}>
            <div className={style.row}>
              <span className={`${style.column} ${style['column-label']}`}>Title:</span>
              <div
                className={`${style.column} ${style['column-values']}`}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>

            {Object.hasOwn(option_include, 'target_markets') ? (
              <>
                {option_include.target_markets[index] &&
                option_include.target_markets[index].traits &&
                option_include.target_markets[index].traits.order
                  ? option_include.target_markets[index].traits.order.map((key, _index) =>
                      option_include.target_markets[index].traits.values[key] &&
                      option_include.target_markets[index].traits.values[key].filtered ? (
                        <div
                          key={`${option_include.target_markets[index].traits.values[key].label}-${_index + 1}`}
                          className={style.row}
                        >
                          <span className={`${style.column} ${style['column-label']}`}>
                            {option_include.target_markets[index].traits.values[key].label}:
                          </span>
                          <div className={`${style.column} ${style['column-values']}`}>
                            {option_include.target_markets[index].traits.values[key].text}
                          </div>
                        </div>
                      ) : null
                    )
                  : option_include.target_markets[index] && option_include.target_markets[index].traits
                    ? option_include.target_markets[index].traits.map((trait, _index) =>
                        trait.filtered && trait.values && 0 < trait.values.length ? (
                          <div key={`${trait.filtered.label}-${_index + 1}`} className={style.row}>
                            <span className={`${style.column} ${style['column-label']}`}>{trait.filtered.label}:</span>
                            <div className={`${style.column} ${style['column-values']}`}>{trait.filtered.text}</div>
                          </div>
                        ) : null
                      )
                    : option_include.target_markets[index] && option_include.target_markets[index].details
                      ? option_include.target_markets[index].details.map((trait, _index) => (
                          <div key={`${trait[0]}-${_index + 1}`} className={style.row}>
                            <span className={`${style.column} ${style['column-label']}`}>{trait[0]}:</span>
                            <div className={`${style.column} ${style['column-values']}`}>{trait[1]}</div>
                          </div>
                        ))
                      : null}

                {option_include.target_markets[index] &&
                option_include.target_markets[index].location &&
                option_include.target_markets[index].location.geo ? (
                  <>
                    <div className={style.row}>
                      <span className={`${style.column} ${style['column-label']}`}>Locations:</span>
                      <div className={`${style.column} ${style['column-values']}`}>
                        {option_include.target_markets[index].location.geo.text}
                      </div>
                    </div>
                    {option_include.target_markets[index].location.geo.data.map((data, _index) => (
                      <div key={`${data.text}-${_index + 1}`} className={style.row}>
                        <span className={`${style.column} ${style['column-label']}`}>
                          {data.text}
                          {0 < data.sub.length ? ':' : ''}
                        </span>
                        <div className={`${style.column} ${style['column-values']}`}>
                          {0 < data.sub.length ? data.sub.join(', ') : <>&nbsp;</>}
                        </div>
                      </div>
                    ))}
                  </>
                ) : null}
              </>
            ) : null}
          </Fragment>
        ))}
      </div>
    </div>
  )

  const renderExcludeOption = () => (
    <div className={style.section}>
      <RowCollapsable
        label={option_exclude.label}
        values={option_exclude.ids || option_exclude.text || option_exclude.titles}
      />
    </div>
  )

  const renderQuotaGroup = () => {
    const title =
      'nested' == quotaType ? (
        <>Nested quota groups</>
      ) : 'balancing' == quotaType ? (
        <>
          Quota balancing
          {root && <SidebarPopup root={root} help={TARGET_HELP} width="300px" />}
        </>
      ) : quotas.some(
          q =>
            Array.isArray(q.traits) &&
            q.traits.some(t => !['country', 'locale'].includes(t.id) && t.filtered && t.values && 0 < t.values.length)
        ) ? (
        <>Organic fielding</>
      ) : null

    const quotaHasContent = quota => {
      if ('nested' == quotaType && quota.name) return true
      if ('balancing' == quotaType && quota.balancing?.preset) return true

      if (Object.hasOwn(quota, 'balancing')) {
        return 0 < (quota.balancing?.traits || []).length
      }
      if (Object.hasOwn(quota, 'traits') && Array.isArray(quota.traits)) {
        return quota.traits.some(
          t => !['country', 'locale'].includes(t.id) && t.filtered && t.values && 0 < t.values.length
        )
      }
      if (Object.hasOwn(quota, 'details') && Array.isArray(quota.details)) {
        return quota.details.some(t => !['country', 'locale'].includes(t[0].toLowerCase()))
      }

      return false
    }

    const quotasHasContent = quotas.some(quotaHasContent)

    if (!title && !quotasHasContent) return null

    return (
      <div className={style.section}>
        {title ? <div className={style['section-title']}>{title}</div> : null}

        {quotas.map((quota, index) => (
          <div key={`quota-${index + 1}`} className={style.section}>
            {'nested' == quotaType ? (
              <div className={style['section-sub-title']} dangerouslySetInnerHTML={{ __html: quota.name }} />
            ) : 'balancing' == quotaType && quota.balancing?.preset ? (
              <div
                className={style['section-sub-title']}
                dangerouslySetInnerHTML={{ __html: quota.balancing.preset }}
              />
            ) : null}

            {Object.hasOwn(quota, 'balancing')
              ? (quota.balancing.traits || []).map(trait => (
                  <RowCollapsable
                    key={`${trait.text}-${index + 1}`}
                    label={trait.text}
                    values={trait.values.map(v => `${v.text} - ${v.value}`)}
                  />
                ))
              : Object.hasOwn(quota, 'traits') && Array.isArray(quota.traits)
                ? quota.traits
                    .filter(trait => !['country', 'locale'].includes(trait.id))
                    .map(trait =>
                      trait.filtered && trait.values && 0 < trait.values.length ? (
                        ['nested', 'organic'].includes(quotaType) && 'location' == trait.id ? (
                          <RowCollapsable
                            key={`${trait.text.split(':')[0]}-${index + 1}`}
                            label={trait.text.split(':')[0]}
                            values={trait.text.split(':')[1]}
                          />
                        ) : (
                          <RowCollapsable key={`${trait.label}-${index + 1}`} label={trait.label} values={trait.text} />
                        )
                      ) : null
                    )
                : Object.hasOwn(quota, 'details') && Array.isArray(quota.details)
                  ? quota.details
                      .filter(trait => !['country', 'locale'].includes(trait[0].toLowerCase()))
                      .map(trait => (
                        <RowCollapsable key={`${trait[0]}-${index + 1}`} label={trait[0]} values={trait[1]} />
                      ))
                  : null}
          </div>
        ))}
      </div>
    )
  }

  return (
    <>
      {0 < quotas.length ? (
        <>
          {renderTargetMarket()}
          {0 < Object.keys(option_include || {}).length ? renderIncludeOption() : renderQuotaGroup()}
          {0 < Object.keys(option_exclude || {}).length ? renderExcludeOption() : null}
        </>
      ) : null}

      {0 < custom_quotas.length ? (
        <div className={style.section}>
          <div className={style['section-title']}>Custom Quota</div>

          <div className={style.section}>
            {custom_quotas.map((custom_quota, index) => (
              <div key={`${custom_quota}-${index + 1}`} className={style.row}>
                <div className={style.column} dangerouslySetInnerHTML={{ __html: custom_quota }} />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </>
  )
}

TargetPanelSurvey.propTypes = {
  root: PropTypes.any,
  model: PropTypes.object
}

TargetPanelSurvey.displayName = 'TargetPanelSurvey'

export default TargetPanelSurvey
